import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ComponentInterface } from '../../../fc-core/src/component-interface';
import getLinearRegressionPoints from './linear-regression';
import getPolynomialRegressionPoints from './polynomial-regression';
import { pluckNumber, pluck, toRaphaelColor } from '../../../fc-core/src/lib';
import { createPolynomial, createLinear } from './utility-functions';
import { addDep } from '../../../fc-core/src/dependency-manager';
import regressionLineAnimation from './regression-line.animation';
addDep({
  name: 'regressionLineAnimation',
  type: 'animationRule',
  extension: regressionLineAnimation
});

var RegressionLineExtension =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(RegressionLineExtension, _ComponentInterface);

  function RegressionLineExtension() {
    var _this;

    _classCallCheck(this, RegressionLineExtension);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RegressionLineExtension).call(this)), _this._config = {
      regressionPoints: []
    }, _this.regressionLine = [];
    return _this;
  }

  _createClass(RegressionLineExtension, [{
    key: "getType",
    value: function getType() {
      return 'extension';
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'regression';
    }
  }, {
    key: "configureAttributes",
    value: function configureAttributes(a) {
      var b = this,
          c = b.getFromEnv('dataSource').chart,
          d = a.config,
          e = d.JSONData,
          f = b._config;
      f.regressionPoints.splice(0, f.regressionPoints.length), f.showYOnX = pluckNumber(e.showyonx, c.showyonx, 1), f.regressionLineColor = toRaphaelColor(pluck(e.regressionlinecolor, c.regressionlinecolor, d.anchorbordercolor, d.lineColor, d.anchorBgColor, 'fff000')), f.polynomialRegressionLineColor = toRaphaelColor(pluck(e.polynomialregressionlinecolor, c.polynomialregressionlinecolor, f.regressionLineColor)), f.regressionLineThickness = pluckNumber(e.regressionlinethickness, c.regressionlinethickness, e.anchorborderthickness, 1), f.polynomialRegressionLineThickness = pluckNumber(e.polynomialregressionlinethickness, c.polynomialregressionlinethickness, f.regressionLineThickness), f.regressionLineAlpha = pluckNumber(e.regressionlinealpha, c.regressionlinealpha, 100), f.polynomialRegressionLineAlpha = pluckNumber(e.polynomialregressionlinealpha, c.polynomialregressionlinealpha, f.regressionLineAlpha), createLinear(c, e) && f.regressionPoints.push(getLinearRegressionPoints(e.data, f.showYOnX)), createPolynomial(c, e) && f.regressionPoints.push(getPolynomialRegressionPoints(e.data, f.showYOnX));
    }
  }, {
    key: "draw",
    value: function draw() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g,
          h = this,
          i = h._config,
          k = h.getFromEnv('xAxis'),
          l = h.getFromEnv('yAxis'),
          j = h.getFromEnv('chart'),
          m = j.getChildren('canvas')[0],
          o = m.config,
          p = h.getLinkedParent(),
          q = p.getState('visible'),
          r = h.getContainer('regressionlinecontainer'),
          s = j.getChildContainer('abovePlotGroup'),
          t = h.getFromEnv('animationManager'),
          u = i.regressionPoints,
          v = [],
          w = [],
          x = h.getGraphicalElement('regressionLineLinear'),
          y = h.getGraphicalElement('regressionLinePolynomial'),
          z = function z() {
        this.hide();
      };

      q || (g = 'disappearing'), r = h.addContainer('regressionlinecontainer', t.setAnimation({
        el: r || 'group',
        attr: {
          name: 'regressionlinecontainer',
          "clip-rect": [o.canvasLeft, o.canvasTop, o.canvasWidth, o.canvasHeight]
        },
        container: s,
        component: h,
        label: 'group'
      }));

      for (var _b, _c = 0; _c < u.length; _c++) {
        if (_b = '', v = u[_c][0], w = u[_c][1], a = w.length, 0 === v.length && 0 === w.length) d = !0, _b += 'M0,0';else if (0 !== v.length && 0 === w.length) d = !1, _b += 'M0,0';else if (0 === v.length) d = !0, _b += 'M' + k.getPixel(w[0].x) + ',' + l.getPixel(w[0].y), _b += 'L' + k.getPixel(w[a - 1].x) + ',' + l.getPixel(w[a - 1].y);else {
          d = !1, _b += 'M' + k.getPixel(w[0].x) + ',' + l.getPixel(w[0].y), _b += ' R' + k.getPixel(w[1].x) + ',' + l.getPixel(w[1].y);

          for (var _c2 = 2; _c2 < a; _c2++) {
            _b += ' ' + k.getPixel(w[_c2].x) + ',' + l.getPixel(w[_c2].y);
          }
        }
        d ? e = {
          opacity: +i.regressionLineAlpha / 100,
          stroke: i.regressionLineColor,
          "stroke-width": i.regressionLineThickness,
          path: _b
        } : f = {
          opacity: +pluck(i.polynomialRegressionLineAlpha, i.regressionLineAlpha) / 100,
          stroke: pluck(i.polynomialRegressionLineColor, i.regressionLineColor),
          "stroke-width": pluck(i.polynomialRegressionLineThickness, i.regressionLineThickness),
          path: _b
        };
      }

      'disappearing' !== g && (x && x.show(), y && y.show()), b = t.setAnimation({
        el: x || 'path',
        container: r,
        component: h,
        doNotRemove: !0,
        attr: 'disappearing' !== g && e,
        callback: 'disappearing' === g && z,
        label: 'path'
      }), x || h.addGraphicalElement('regressionLineLinear', b), c = t.setAnimation({
        el: y || 'path',
        container: r,
        component: h,
        doNotRemove: !0,
        attr: 'disappearing' !== g && f,
        callback: 'disappearing' === g && z,
        label: 'path'
      }), y || h.addGraphicalElement('regressionLinePolynomial', c);
    }
  }]);

  return RegressionLineExtension;
}(ComponentInterface);

export { RegressionLineExtension as default };